/*
 * JobCalendar Messages
 *
 * This contains all the text for the JobCalendar component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'src.pages.ProjectDetailsPage.components.JobCalendar';

export default defineMessages({
  appliedCountShortLabel: {
    id: `${scope}.appliedCountShortLabel`,
    defaultMessage: '{count} applied',
  },
  closeTimeWindowsLabel: {
    id: `${scope}.closeTimeWindowsLabel`,
    defaultMessage: 'Close',
  },
  applicationsCountLabel: {
    id: `${scope}.applicationsCountLabel`,
    defaultMessage:
      '{count, plural, one {# application} other {# applications}}',
  },
  timeWindowsLabel: {
    id: `${scope}.timeWindowsLabel`,
    defaultMessage: 'Applications on {date}',
  },
  timeWindowsLoadingLabel: {
    id: `${scope}.timeWindowsLoadingLabel`,
    defaultMessage: 'Loading time windows...',
  },
  timeWindowsErrorLabel: {
    id: `${scope}.timeWindowsErrorLabel`,
    defaultMessage: 'Could not load time windows.',
  },
  waitlistedLabel: {
    id: `${scope}.waitlistedLabel`,
    defaultMessage: 'Waitlisted',
  },
  cancelLabel: {
    id: `${scope}.cancelLabel`,
    defaultMessage: 'Cancel',
  },
  reapplyLabel: {
    id: `${scope}.reapplyLabel`,
    defaultMessage: 'Re-apply',
  },
  confirmAcceptButton: {
    id: `${scope}.confirmAcceptButton`,
    defaultMessage: 'Accept Selected',
  },
  acceptModalLabel: {
    id: `${scope}.acceptModalLabel`,
    defaultMessage: 'Please specify a reason for accepting',
  },
  rebookApplicationConfirmMessage: {
    id: `${scope}.rebookApplicationConfirmMessage`,
    defaultMessage: 'Please specify a reason for uncancelling',
  },
  confirmRejectButton: {
    id: `${scope}.confirmRejectButton`,
    defaultMessage: 'Reject Selected',
  },
  rejectModalLabel: {
    id: `${scope}.rejectModalLabel`,
    defaultMessage: 'Please specify a reason for rejecting',
  },
  resetApplicationConfirmMessage: {
    id: `${scope}.resetApplicationConfirmMessage`,
    defaultMessage: 'Are you sure you want to apply back to this Job?',
  },
  cancelApplicantConfirmTitle: {
    id: `${scope}.cancelApplicantConfirmTitle`,
    defaultMessage: 'Please specify a reason for cancelling',
  },
  multipleApplicationsReceivedLabel: {
    id: `${scope}.multipleApplicationsReceivedLabel`,
    defaultMessage: '{count} Applications Received',
  },
  applicationReceivedTooltip: {
    id: `${scope}.applicationReceivedTooltip`,
    defaultMessage: '1 Application Received',
  },
  availableLabel: {
    id: `${scope}.availableLabel`,
    defaultMessage: 'Available',
  },
  unpaidLeaveLabel: {
    id: `${scope}.unpaidLeaveLabel`,
    defaultMessage: 'Unpaid Leave',
  },
  weekStatsColumnLabel: {
    id: `${scope}.weekStatsColumnLabel`,
    defaultMessage: 'Week Stats',
  },
});
